import { z } from "zod";

export const statusResponseSchema = z.object({
  status: z.string(),
});

export const putStatusResponseSchema = statusResponseSchema.extend({
  id: z.string()
})

export type StatusResponse = z.infer<typeof statusResponseSchema>;
export type PutStatusResponse = z.infer<typeof putStatusResponseSchema>;